import React, { Fragment, useEffect, useState } from 'react'
import AddToTeam from './Add'
import ListTeams from './List'
import EmptyTeamCard from './_Components/EmptyTeamCard'

import { Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../../_actions/alert.actions';
import { usersService } from '../../../../../_services/users.service';

export default function LicensedTeam({ user }) {
  const dispatch = useDispatch(null)

  const [loading, setLoading] = useState(true)
  const [addToTeam, setAddToTeam] = useState(false)
  const [licensedTeam, setLicensedTeam] = useState(null)

  useEffect(() => {
    usersService.getLicensedTeam(user.userId)
      .then((response) => {
        if (response && response.data) {
          setLicensedTeam(response.data.data)
        }
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve licensed team at this time. Please try again.'));
      })
      .then(() => {
        setLoading(false)
      })
  }, [dispatch, user.userId])

  const reloadData = () => {
    usersService.getLicensedTeam(user.userId)
      .then((response) => {
        if (response && response.data) {
          setLicensedTeam(response.data.data)
          setAddToTeam(false)
        }
      })
      .catch(() => {
        dispatch(alertActions.error('Could not retrieve licensed team at this time. Please try again.'));
      })
  }

  if (loading) {
    return <Spinner animation='border'/>
  }

  return (
    <Fragment>
      { addToTeam &&
        <AddToTeam
          user={user}
          handleBack={reload => {
            if (reload) {
              reloadData()
            } else {
              setAddToTeam(false)
            }
          }}
        />
      }

      { licensedTeam.length > 0 && !addToTeam &&
        <ListTeams
          user={user}
          reload={reloadData}
          licensedTeams={licensedTeam}
          handleShowAddToTeam={() => setAddToTeam(true)}
        />
      }

      { licensedTeam.length === 0 && !addToTeam &&
        <EmptyTeamCard
          handleShowAddToTeam={() => setAddToTeam(true)}
        />
      }
    </Fragment>
  )
}
